import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Printer } from 'lucide-react';

import PrintableMasterGrid from '../../components/print/PrintableMasterGrid';
import Button from '../../components/ui/Button';
import useIsMobile from '../../hooks/useIsMobile';

export default function Print() {
  const isMobile = useIsMobile();

  return (
    <div>
      <div className="ss-print__header">
        <Link to="/admin" className="ss-back-link"><ArrowLeft size={16} aria-hidden="true" /> Back to admin</Link>
        <h1>Print</h1>
        <p className="ss-admin__lede">Design and print templates.</p>
        {!isMobile && (
          <Button size="sm" variant="ghost" className="ss-print__print-btn" onClick={() => window.print()}>
            <Printer size={16} aria-hidden="true" /> Print
          </Button>
        )}
      </div>
      {isMobile ? (
        <div className="ss-state">
          <h2>Larger Screen Needed</h2>
          <p>The label designer needs a larger screen. Please open this page on a device with a higher resolution.</p>
        </div>
      ) : (
        <PrintableMasterGrid />
      )}
    </div>
  );
}
